(function(){
  'use strict';

  function injectCheckoutPolish(){
    if(document.getElementById('pmy-checkout-field-polish-2026')) return;
    var s=document.createElement('style');
    s.id='pmy-checkout-field-polish-2026';
    s.textContent=`
      #pmy-checkout-drawer #sticky-checkout-form .pmy-checkout-form-grid{
        align-items:end!important;
      }
      #pmy-checkout-drawer #sticky-checkout-form .pmy-checkout-field--phone,
      #pmy-checkout-drawer #sticky-checkout-form .pmy-checkout-field--email{
        min-width:0!important;
      }
      #pmy-checkout-drawer #sticky-checkout-form .pmy-checkout-phone{
        display:grid!important;
        grid-template-columns:104px minmax(0,1fr)!important;
        gap:10px!important;
        width:100%!important;
        min-width:0!important;
      }
      #pmy-checkout-drawer #sticky-checkout-form #chk-phone-number{
        width:100%!important;
        min-width:0!important;
      }
      #pmy-checkout-drawer #sticky-checkout-form .phone-prefix-trigger{
        width:auto!important;
        min-width:96px!important;
        max-width:128px!important;
        padding-inline:12px!important;
        justify-content:center!important;
        gap:7px!important;
        white-space:nowrap!important;
      }
      #pmy-checkout-drawer #sticky-checkout-form .phone-prefix-trigger #prefix-flag img{
        width:20px!important;height:15px!important;display:block!important;object-fit:cover!important;border-radius:3px!important;
      }
      #pmy-checkout-drawer #sticky-checkout-form .pmy-select-trigger,
      #pmy-checkout-drawer #sticky-checkout-form .pmy-date-trigger,
      #pmy-checkout-drawer #sticky-checkout-form .phone-prefix-trigger,
      #pmy-checkout-drawer #sticky-checkout-form input:not([type='hidden']){
        border-radius:12px!important;
        min-height:44px!important;
        height:44px!important;
        background:rgba(255,255,255,.86)!important;
        border:1px solid rgba(0,102,0,.18)!important;
        box-shadow:none!important;
        font-family:var(--font-familia-montserrat,'Montserrat',sans-serif)!important;
      }
      #pmy-checkout-drawer #sticky-checkout-form .pmy-select-trigger:hover,
      #pmy-checkout-drawer #sticky-checkout-form .pmy-select-trigger[aria-expanded='true'],
      #pmy-checkout-drawer #sticky-checkout-form .pmy-date-trigger:hover,
      #pmy-checkout-drawer #sticky-checkout-form .pmy-date-trigger.is-open,
      #pmy-checkout-drawer #sticky-checkout-form .phone-prefix-trigger:hover,
      #pmy-checkout-drawer #sticky-checkout-form .phone-prefix-trigger[aria-expanded='true'],
      #pmy-checkout-drawer #sticky-checkout-form input:not([type='hidden']):focus{
        border-color:#006600!important;
        box-shadow:0 0 0 3px rgba(0,102,0,.08)!important;
        outline:none!important;
      }
      .pmy-select-panel,
      .pmy-country-panel{
        border-radius:18px!important;
        border:1px solid rgba(0,102,0,.14)!important;
        box-shadow:0 18px 48px rgba(25,55,31,.16)!important;
        overflow:hidden!important;
        font-family:var(--font-familia-montserrat,'Montserrat',sans-serif)!important;
      }
      .pmy-select-option{
        min-height:44px!important;
        padding:11px 14px!important;
      }
      .pmy-select-option:hover{
        background:rgba(0,102,0,.06)!important;
      }
      .pmy-select-option.active{
        background:rgba(0,102,0,.09)!important;
        color:#006600!important;
      }
      .pmy-country-search{
        padding:12px!important;
      }
      .pmy-country-search input{
        min-height:42px!important;
        border-radius:999px!important;
        padding-inline:14px!important;
      }
      .pmy-checkout-calendar.flatpickr-calendar{
        width:320px!important;
        padding:14px!important;
        border-radius:22px!important;
        border:1px solid rgba(0,102,0,.14)!important;
        box-shadow:0 18px 48px rgba(25,55,31,.16)!important;
        font-family:var(--font-familia-montserrat,'Montserrat',sans-serif)!important;
      }
      .pmy-checkout-calendar .flatpickr-months{
        margin-bottom:8px!important;
      }
      .pmy-checkout-calendar .flatpickr-monthDropdown-months,
      .pmy-checkout-calendar .numInputWrapper input{
        font-weight:700!important;
        font-family:inherit!important;
      }
      .pmy-checkout-calendar .flatpickr-weekday{
        font-weight:700!important;
        color:#3e3e3e!important;
      }
      .pmy-checkout-calendar .flatpickr-day{
        border-radius:50%!important;
      }
      .pmy-checkout-calendar .flatpickr-day.selected{
        background:#006600!important;
        border-color:#006600!important;
        color:#fff!important;
      }
      /* PMY 2026-10-05 | checkout row alignment */
      #pmy-checkout-drawer #sticky-checkout-form .pmy-checkout-form-grid{
        align-items:start!important;
      }
      #pmy-checkout-drawer #sticky-checkout-form .pmy-checkout-field--email,
      #pmy-checkout-drawer #sticky-checkout-form .pmy-checkout-field--phone{
        align-self:start!important;
      }
      @media(min-width:1200px){
        #pmy-checkout-drawer #sticky-checkout-form .pmy-checkout-field--email,
        #pmy-checkout-drawer #sticky-checkout-form .pmy-checkout-field--phone{
          grid-column:auto!important;
        }
      }
      @media(max-width:1199px){
        #pmy-checkout-drawer #sticky-checkout-form .pmy-checkout-field--email,
        #pmy-checkout-drawer #sticky-checkout-form .pmy-checkout-field--phone{
          grid-column:1/-1!important;
        }
      }
      @media(max-width:479px){
        .pmy-checkout-calendar.flatpickr-calendar{
          width:min(320px,calc(100vw - 24px))!important;
        }
        #pmy-checkout-drawer #sticky-checkout-form .pmy-checkout-phone{
          grid-template-columns:98px minmax(0,1fr)!important;
        }
      }
    `;
    document.head.appendChild(s);
  }

  function quarantineLegacyCheckout(){
    var modal=document.getElementById('checkoutModalGrid');
    if(!modal || modal.dataset.pmyQuarantined==='1') return;
    modal.dataset.pmyQuarantined='1';

    var nodes=[modal].concat(Array.prototype.slice.call(modal.querySelectorAll('[id]')));
    var map={};
    nodes.forEach(function(el){
      if(!el.id || el.id.indexOf('legacy-')===0) return;
      var old=el.id;
      var next='legacy-'+old;
      map[old]=next;
      el.id=next;
    });

    modal.querySelectorAll('[for]').forEach(function(el){
      var v=el.getAttribute('for');
      if(map[v]) el.setAttribute('for',map[v]);
    });
    modal.querySelectorAll('[aria-controls],[aria-labelledby]').forEach(function(el){
      ['aria-controls','aria-labelledby'].forEach(function(attr){
        var v=el.getAttribute(attr);
        if(!v) return;
        el.setAttribute(attr,v.split(/\s+/).map(function(id){return map[id]||id;}).join(' '));
      });
    });

    modal.hidden=true;
    modal.setAttribute('aria-hidden','true');
    modal.style.display='none';
  }

  function markModernFields(){
    var form=document.getElementById('sticky-checkout-form');
    if(!form) return;
    var email=document.getElementById('chk-email');
    var phone=document.getElementById('chk-phone-number');
    var name=document.getElementById('chk-name');
    if(name && name.closest('.pmy-checkout-field')) name.closest('.pmy-checkout-field').classList.add('pmy-checkout-field--name','pmy-checkout-field--full');
    if(email && email.closest('.pmy-checkout-field')) email.closest('.pmy-checkout-field').classList.add('pmy-checkout-field--email');
    if(phone && phone.closest('.pmy-checkout-field')){
      var field=phone.closest('.pmy-checkout-field');
      field.classList.remove('pmy-checkout-field--full');
      field.classList.add('pmy-checkout-field--phone');
    }
  }

  function productIdFromButton(btn){
    var inline=btn.getAttribute('onclick')||'';
    var m=inline.match(/tour-data-(\d+)/);
    if(m) return m[1];
    var id=btn.getAttribute('data-product-id');
    if(id) return id;
    var card=btn.closest('[data-product-id]');
    return card ? card.getAttribute('data-product-id') : '';
  }

  function openModernCheckout(btn){
    var productId=productIdFromButton(btn);
    if(!productId) return false;
    var dataId='pmy-checkout-data-'+productId;
    if(window.PMYCheckoutDrawer && typeof window.PMYCheckoutDrawer.select==='function'){
      window.PMYCheckoutDrawer.select(dataId);
      return true;
    }
    if(typeof window.triggerCheckout==='function'){
      window.triggerCheckout(dataId,true);
      return true;
    }
    return false;
  }

  document.addEventListener('click',function(e){
    var btn=e.target.closest && e.target.closest('.pmy-cpg-btn');
    if(!btn) return;
    e.preventDefault();
    e.stopPropagation();
    e.stopImmediatePropagation();
    btn.removeAttribute('data-bs-toggle');
    btn.removeAttribute('data-bs-target');
    if(!openModernCheckout(btn)) setTimeout(function(){openModernCheckout(btn);},60);
  },true);

  function init(){
    injectCheckoutPolish();
    quarantineLegacyCheckout();
    markModernFields();
    setTimeout(markModernFields,150);
    setTimeout(markModernFields,650);
  }

  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',init,{once:true});
  else init();
})();
